// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/assets/global.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import utilPlugin from 'clf-vue-util'
import urlPlugin from 'clf-vue-url'
import httpPlugin from 'clf-vue-http'
import pagePlugin from 'clf-vue-page'
import formatPlugin from 'clf-vue-format'
import titlePlugin from 'clf-vue-title'
import commonPlugin from './plugins/common'
import notifierPage from './modules/notifier-page/notifierPage'

require('es6-promise').polyfill()
Vue.use(ElementUI)
Vue.use(utilPlugin)
Vue.use(urlPlugin)
Vue.use(httpPlugin, {
  serverUrl: '/api',
  loginUrl: '#/userAuth/login',
  csrfUrl: '/common/getToken.action'
})
Vue.use(pagePlugin)
Vue.use(formatPlugin)
Vue.use(titlePlugin)
Vue.use(commonPlugin)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App},
  mounted: function () {
    document.getElementById('page-loading').style.display = 'none'
    document.getElementById('body').style.display = 'block'
  }
})

router.beforeEach((to, from, next) => {
  notifierPage.loading()
  next()
})

router.afterEach(route => {
  notifierPage.hide()
  let arr = document.getElementsByClassName('_clf_notifier')
  for (let i = 0, len = arr.length; i < len; i++) {
    arr[i].remove()
  }
  window.scrollTo(0, 0)
  Vue.prototype.$getCsrfToken()
})



// WEBPACK FOOTER //
// ./src/main.js